import Select from '../Select';
import Toggle from '../Toggle.jsx';
import TextArea from '../TextArea.jsx';

export const ManualEntryMethodOptions = {
    cash: 'Cash',
    check: 'Check',
    cashapp: 'Square Cash App',
    venmo: 'Venmo',
    zelle: 'Zelle',
    other: 'Other',
};

const ManualEntryForm = ({
    method,
    setMethod,
    isFullyPaid,
    setIsFullyPaid,
    showMarkFullyPaid,
    notes,
    setNotes,
}) => {
    return (
        <div>
            <Select
                label="Received via"
                onChange={setMethod}
                value={method}
                options={ManualEntryMethodOptions}
                className="mb-4"
            />

            {showMarkFullyPaid && (
                <div className="flex items-center space-x-4 mb-4">
                    <Toggle enabled={isFullyPaid} setEnabled={setIsFullyPaid} />
                    <div className="text-gray-500">Mark this as fully paid</div>
                </div>
            )}

            <TextArea
                label="Notes"
                value={notes}
                onChange={setNotes}
                className="mb-4"
            />
        </div>
    );
};

export default ManualEntryForm;
